const confirmPrompt = {
  current: async (_title?: string, _content?: string, _textConfirm?: string) =>
    true
}

export const getConfirmPromptRef = (): typeof confirmPrompt => confirmPrompt
